import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionMutation, deleteQuestionMutationVariables } from '../generated/deleteQuestionMutation';
import { questionFieldsFragment } from '../models/Question';

/**
 * Get a callback to delete a Question in the store.
 */
export function useDeleteQuestionCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionMutation, deleteQuestionMutationVariables>(
        gql`
            mutation deleteQuestionMutation ($id: ID!) {
                deleteQuestion(id: $id) {
                    ...questionFields
                }
            }

            ${questionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
